import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Person from '@mui/icons-material/Person';
import Badge from '@mui/material/Badge';
import Link from '@mui/material/Link';
import { NavbarButton } from '../../buttons';
import { NAVBAR_PROFILE_CLASS_NAME } from '../../../theme/constants/link';
import { NAVBAR_PROFILE_BUTTON_CLASS_NAME } from '../../../theme/constants/icon-button';

const ProfileNavItem = ({ credentialsMissing, profileMissing, text, gap }) => (
  <Link
    component={NavLink}
    to="/app/profile"
    className={NAVBAR_PROFILE_CLASS_NAME}
    sx={{ display: 'flex', alignItems: 'center', gap }}
  >
    <NavbarButton id="navbar-profile-button" className={NAVBAR_PROFILE_BUTTON_CLASS_NAME}>
      <Badge
        invisible={!credentialsMissing && !profileMissing}
        badgeContent={credentialsMissing + profileMissing}
        color="primary"
      >
        <Person sx={{ color: 'white' }} />
      </Badge>
    </NavbarButton>
    {text && text}
  </Link>
);

ProfileNavItem.propTypes = {
  credentialsMissing: PropTypes.number.isRequired,
  profileMissing: PropTypes.number.isRequired,
  text: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ProfileNavItem.defaultProps = {
  text: null,
  gap: 1,
};

export default ProfileNavItem;
